import React from "react";
import styles from "../../../../../../styles/Campaigns/CampaignLogs.module.scss";
import { getUserTimeZone } from "../../../../../../utils";
import { formatValidityPeriod } from "../../../../../../utils/formatValidity";
import InfoBlock from "../../../../../common/InfoBlock";
import { commonConfig, fillMissingValidityWithOldValues } from "../utils";
import { LogRenderContext } from "../LogRenderer";

// Target Group Details Panel Component
const TargetGroupDetailsPanel = () => {
  const { log } = React.useContext(LogRenderContext);
  const { targetGroups } = log.dataSnapshot;
  const { targetGroups: targetGroupsNew } = log.changedFields || {};
  if (!targetGroups || targetGroups.length === 0) {
    return (
      <div className={styles.noDataContainer}>
        <div>No target groups found</div>
      </div>
    );
  }

  return (
    <div>
      {targetGroups.map((targetGroup, index) => {
        const targetGroupNew = targetGroupsNew?.find((tg) => tg.id === targetGroup.id);
        return (
          <div key={targetGroup.id} className={styles.targetGroupContainer}>
            <InfoBlock
              header={`${targetGroup.name || `Target Group ${index + 1}`}`}
              subHeader={`ID: ${targetGroup.code || targetGroup.id}`}
              className={styles.changeTracking}
              config={commonConfig([
                {
                  title: "Target Group Name & ID",
                  value: {
                    old: `${targetGroup?.name} (${targetGroup?.code})`,
                    new: targetGroupNew
                      ? `${targetGroupNew?.name} (${targetGroupNew?.code})`
                      : undefined,
                  },
                },
                {
                  title: `Validity (${getUserTimeZone().abbr})`,
                  value: {
                    old: formatValidityPeriod(targetGroup?.validity),
                    new: formatValidityPeriod(
                      fillMissingValidityWithOldValues(
                        targetGroup?.validity,
                        targetGroupNew?.validity
                      )
                    ),
                  },
                },
                {
                  title: "Theatres",
                  value: {
                    old: targetGroup?.noOfTheatres,
                    new: targetGroupNew?.noOfTheatres,
                  },
                },
                {
                  title: "Screens",
                  value: {
                    old: targetGroup?.noOfScreens,
                    new: targetGroupNew?.noOfScreens,
                  },
                },
              ])}
            />
          </div>
        );
      })}
    </div>
  );
};
export default TargetGroupDetailsPanel;
